import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ProjectChecklist } from '@portal-core/project-checklists/models/project-checklist.model';
import { InputObservable } from '@portal-core/util/input-observable.decorator';
import { Observable, map } from 'rxjs';

interface ChartColData {
  Legend: string;
  Count: number;
  Total: number;
  Color: string;
}

@Component({
  selector: 'mc-project-checklist-table',
  templateUrl: './project-checklist-table.component.html',
  styleUrls: ['./project-checklist-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ProjectChecklistTableComponent implements OnInit {
  @Input() checklist: ProjectChecklist;
  @InputObservable('checklist') checklist$: Observable<ProjectChecklist>;

  tableDisplayedColumns: string[] = ['name', 'item', 'percent'];
  tableColumnPaletteNames: string[] = ['chart-1', 'chart-2', 'chart-3', 'chart-4', 'chart-5', 'chart-6'];
  parsedTableData$: Observable<ChartColData[]>;

  ngOnInit() {
    this.parsedTableData$ = this.checklist$
      .pipe(
        map((checklist) => {
          if (checklist) {
            return this.parseTableData(checklist);
          } else {
            return null;
          }
        })
      );
  }

  parseTableData(checklist: ProjectChecklist): ChartColData[] {
    const chartData = checklist.Analytics.ColumnFileCounts;
    const chartColsData = [];
    const indexes = Object.keys(chartData);
    let indexesWithOrder = indexes.map(index => {
      return { index, Order: chartData[index][0].Order };
    });
    indexesWithOrder = indexesWithOrder.sort((a, b) => a.Order > b.Order ? 1 : -1);
    for (let i = 0; i < indexesWithOrder.length; i++) {
      const index = indexesWithOrder[i].index;
      const item = chartData[index][0];
      chartColsData.push({
        Legend: item.Legend,
        Count: item.Count,
        Total: item.Total,
        Percent: item.Percent,
        Color: this.tableColumnPaletteNames[i % this.tableColumnPaletteNames.length]
      });
    }
    return chartColsData;
  }
}
